const KEYBOARD_OPEN_THRESHOLD_PX = 150

/**
 * Tracks mobile software keyboard via visualViewport.
 * Returns unsubscribe function.
 */
export function trackVisualKeyboard(onChange) {
  if (typeof window === 'undefined' || !window.visualViewport) {
    return () => {}
  }

  let maxViewportHeight = window.visualViewport.height

  const sync = () => {
    const height = window.visualViewport.height

    if (height > maxViewportHeight) {
      maxViewportHeight = height
    }

    const isOpen = maxViewportHeight - height > KEYBOARD_OPEN_THRESHOLD_PX

    // When closed, re-baseline so address-bar / chrome shifts don't stick as "open"
    if (!isOpen) {
      maxViewportHeight = height
    }

    onChange(isOpen)
  }

  // Safety net: some WebViews don't restore viewport height on keyboard close
  const onFocusOut = () => {
    setTimeout(() => {
      const tag = document.activeElement?.tagName
      if (tag !== 'INPUT' && tag !== 'TEXTAREA') {
        maxViewportHeight = Math.max(maxViewportHeight, window.visualViewport.height)
        onChange(false)
      }
    }, 100)
  }

  window.visualViewport.addEventListener('resize', sync)
  document.addEventListener('focusout', onFocusOut)

  return () => {
    window.visualViewport.removeEventListener('resize', sync)
    document.removeEventListener('focusout', onFocusOut)
  }
}
